export default {
    en: 'English',
    du: 'Dutch',
    fr: 'française (French)'
};
  